import { FC } from 'react';
import { Dialog, DialogContent, DialogFooter, DialogTitle } from '../../../ui/feedback/Dialog';
import { useFavoritesEnabled } from '../../../utils/useFavoritesEnabled';
import { useDialogScroll } from '../../feedback/hooks/useDialogScroll';
import { DataTestId } from '../../layout/DataTestIdWrapper';
import { SaveToCollectionContent } from './parts/SaveToCollectionContent/SaveToCollectionContent';
import {
    SaveToCollectionFooter,
    shouldShowSaveFooter,
} from './parts/SaveToCollectionFooter/SaveToCollectionFooter';
import { TitleContent } from './parts/TitleContent/TitleContent';
import { SaveToCollectionDrawerProps } from './types';

export const SaveToCollectionDrawer: FC<SaveToCollectionDrawerProps> = ({
    collections,
    isCollectionsLoading,
    onClose,
    onSaveToExistentCollection,
    values,
    handlers,
    step,
    isNotRegistered,
    onAddClick,
}) => {
    const isFavoritesEnabled = useFavoritesEnabled();

    const { modalContentRef, atTop, atBottom } = useDialogScroll();

    const showFooter = shouldShowSaveFooter(step, isFavoritesEnabled);

    return (
        <Dialog onClose={onClose} dataTestId={DataTestId.SAVE_TO_COLLECTION_DRAWER}>
            <DialogTitle withBorderBottom={!atTop} onClose={onClose} minHeight={56}>
                <TitleContent step={step} />
            </DialogTitle>
            <DialogContent ref={modalContentRef} py={0} px={0}>
                <SaveToCollectionContent
                    step={step}
                    collections={collections}
                    isCollectionsLoading={isCollectionsLoading}
                    onSaveToExistentCollection={onSaveToExistentCollection}
                    onAddClick={onAddClick}
                    onClose={onClose}
                    values={values}
                    handlers={handlers}
                    isFavoritesEnabled={isFavoritesEnabled}
                />
            </DialogContent>
            {showFooter ? (
                <DialogFooter withBorderTop={!atBottom} minHeight={76}>
                    <SaveToCollectionFooter
                        step={step}
                        onAddClick={onAddClick}
                        onSubmit={handlers.onSubmit}
                        values={values}
                        isNotRegistered={isNotRegistered}
                    />
                </DialogFooter>
            ) : null}
        </Dialog>
    );
};
